<template>
  <div id="appPage" style="height: 100%;background: #efefef;overflow: hidden">
    <router-view />
  </div>
</template>
<script>
import util from "@/util/util";
export default {
  name: "App",
  components: {
  },
  data() {
    return {

    };
  },
  watch: {

  },
  async created() {
    // 切换页面主题
    let themeType = util.getCookie("UserPageTheme");
    if (!themeType) {
      themeType = "Dark"
    }
    // 切换主题
    window.document.documentElement.setAttribute( "data-theme", themeType);
  },
  mounted() {
  },
  methods: {

  },
  beforeUnmount() {

  }
};
</script>
<style lang="scss">
@import "@/assets/css/el-dialog";
@import "@/assets/css/el-drawer";
@import "@/assets/css/el-input";
* {
  list-style: none;
}

body {
  margin: 0;
  padding: 0 !important;
  overflow: hidden;
}

html, body {
  height: 100%;
  // 通用颜色
  --yq-border-color: #e0e2e9;
  --yq-border-color-2: #e1e1e1;
  --yq-shadow: rgba(0, 0, 0, 0.1);
  --yq-background-color: #f5f7f9;
  --yq-font-color-info: #ccc;
  --yq-font-color-desc: #999;
  --yq-font-color-base: #333;
  --yq-font-color-tips: #666;
  --yq-font-size-base: 14px;
  --yq-font-size-small: 12px;
  --yq-font-size-mini: 10px;
  --yq-font-size-large: 18px;
  --yq-font-size-small-mobile: 18px;
  --yq-font-size-mini-mobile: 14px;
  --yq-font-size-large-mobile: 22px;
  --yq-font-size-large-mobile-2: 26px;
  font-size: 14px;
}
// 默认样式,H5页面统一用这个样式
.defaultViewStyle{
  box-sizing: border-box;
  padding: 10px;
  height: 100%;
  background-color: #FFF;
  border-radius: 0 0 10px 10px;
  overflow: auto;
  position: relative;
}
// 默认样式，移动端页面统一用这个样式
.mobileViewStyle{
  box-sizing: border-box;
}

#appPage{
  >div{
    height: 100%;
    overflow: hidden;
  }
}
// 滚动条
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
/* 修改滚动条轨道的颜色 */
::-webkit-scrollbar-track {
  background: var(--el-color-primary-light-9);
}
/* 修改滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
  background: var(--el-color-info-light-5);
  border-radius: 4px;
}
/* 当滑块被激活（例如，鼠标按下）时的样式 */
::-webkit-scrollbar-thumb:active {
  background: var(--el-color-info-light-3);
}
</style>
